import CreatePolicyDIT from "../../components/dit/createPolicy/createPolicy";
import EndpointRulesLogs from "../../components/dit/endpointsRules/logs/logs";
import EndpointRulesPolicies from "../../components/dit/endpointsRules/policies/policies";
import EndpointRulesRequests from "../../components/dit/endpointsRules/requests/requests";

const ditRouter = [
    { path: 'createPolicy', element: <CreatePolicyDIT /> },
    { 
        path: "endpointRules/*", children: [
            { path: "logs", element: <EndpointRulesLogs /> },
            { path: "requests", element: <EndpointRulesRequests /> },
            { path: "policies", element: <EndpointRulesPolicies /> }
        ] 
    }
]

export default ditRouter;